/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type CreditLedgerExportRequestCategoriesItem = typeof CreditLedgerExportRequestCategoriesItem[keyof typeof CreditLedgerExportRequestCategoriesItem];


export const CreditLedgerExportRequestCategoriesItem = {
  contact_reveal: 'contact_reveal',
  export: 'export',
  ats_sync: 'ats_sync',
  allocation: 'allocation',
  seats: 'seats',
  plan_change: 'plan_change',
  grant: 'grant',
  reset: 'reset',
  other: 'other',
} as const;
